module.exports = __webpack_public_path__ + "img/landing-page.857012c7.jpg";